import Skeleton from 'react-loading-skeleton'
import styled from 'styled-components'
import { ResponsiveImage } from '@velasca/ui/responsive-image'

export const Product = styled.div`
  display: flex;
  flex-direction: column;
  height: 100%;
  font-family: ${({ theme }) => theme.fonts.brand};
`

export const Header = styled.div`
  display: flex;
  padding: 1.6rem;
  gap: 1.6rem;

  .safari-lower-than-15 & {
    height: 100%;
  }
`

export const Images = styled.div`
  min-height: 22rem;
  max-height: 32rem;
  position: relative;
  aspect-ratio: 4/5;
  height: 100%;

  .safari-lower-than-15 & {
    min-height: auto;
    max-height: auto;
  }
`

export const ProductTitleLink = styled.a`
  display: block;

  &:hover,
  &:link,
  &:visited,
  &:active {
    text-decoration: none;
  }
`

export const Details = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
`

export const StaffPickImage = styled(ResponsiveImage)`
  position: absolute;
  z-index: 1;
  width: 7rem;
  top: 0;
  right: 0;
`

export const ProductImageSkeleton = styled(Skeleton)`
  aspect-ratio: 4/5;

  .safari-lower-than-15 & {
    max-width: 40vw;
  }
`

export const ProductImage = styled(ResponsiveImage)`
  object-fit: cover;
  width: 100%;
  height: 100%;

  .safari-lower-than-15 & {
    max-width: 40vw;
    object-fit: contain;
  }
`

export const Title = styled.h1`
  font-size: 1.6rem;
  line-height: 2.5rem;
`

export const ProductType = styled.span`
  font-size: 1.6rem;
  line-height: 1.6rem;
`

export const Spacer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.4rem;
  margin: 1.5rem 0 1rem 0;
`

export const StyledQuickAddList = styled.ol`
  padding: 0;
  margin: 0;
  font-family: ${({ theme }) => theme.fonts.brand};
  text-transform: uppercase;
  overflow: scroll;
`
